export default __webpack_public_path__ + "static/media/atomica.7565ef48.gif";